export enum GameType {
    None = 0,
    Baccarat = 1 << 0,
    Dragon = 1 << 1,
    MultiBet = 3, //For client use only
    SicBo = 1 << 2,
    FanTan = 1 << 3,
    Roulette = 1 << 4,
    SlotGame = 1 << 5,
    Lotto48 = 1 << 6,
    MiniGame = 1 << 7,
    LotterySideBet = 1 << 8,
    Blackjack = 1 << 9,
    AnimatedGame = 1 << 10,
    P2PGame = 1 << 11,
    SqueezeBaccarat = 1 << 12,
    MoneyWheel = 1 << 13,
    PokDeng = 1 << 14,
    AndarBahar = 1 << 15,
    TeenPatti2020 = 1 << 16,
    SeDie = 1 << 17,
    CarnivalTreasure = 1 << 18,
    ThaiHiLo = 1 << 19, //跟 Limit red 返來 game type
    FishPrawnCrab = 1 << 20,
    UltraRoulette = 1 << 21,
    Blackjack2 = 1 << 22,
    GameShow = 1 << 30,
}
export enum CombineGameType {
    None = GameType.None,
    Baccarat = GameType.Baccarat,
    Dragon = GameType.Dragon,
    // MultiBet = GameType.MultiBet,
    Dice = GameType.SicBo | GameType.ThaiHiLo | GameType.FishPrawnCrab,
    FanTan = GameType.FanTan,
    Roulette = GameType.Roulette | GameType.UltraRoulette,
    SlotGame = GameType.SlotGame,
    Lotto = GameType.Lotto48,
    MiniGame = GameType.MiniGame,
    LotterySideBet = GameType.LotterySideBet,
    Blackjack = GameType.Blackjack | GameType.Blackjack2,
    AnimatedGame = GameType.AnimatedGame,
    P2PGame = GameType.P2PGame,
    SqueezeBaccarat = GameType.SqueezeBaccarat,
    MoneyWheel = GameType.MoneyWheel,
    PokDeng = GameType.PokDeng,
    Poker = GameType.AndarBahar | GameType.TeenPatti2020,
    SeDie = GameType.SeDie,
    CarnivalTreasure = GameType.CarnivalTreasure,
    GameShow = GameType.CarnivalTreasure | GameType.GameShow,
}
